import { useId, type ReactNode } from 'react'
import LabMark from './LabMark'
import { eyebrowClass } from './ui'

type Props = {
  title: string
  description?: string
  children: ReactNode
  footer?: ReactNode
}

export default function AuthPanel({ title, description, children, footer }: Props) {
  const titleId = useId()

  return (
    <div className="grid items-start gap-10 py-1 md:grid-cols-[1fr_1.05fr] md:gap-16 md:py-6">
      <aside className="hidden pt-8 md:block" aria-label="About the lab">
        <LabMark className="h-12 w-12 text-brand" />
        <p className={`${eyebrowClass} mt-8 text-muted`}>A clearer view of your game</p>
        <p className="mt-5 max-w-sm font-serif text-5xl leading-[1.1] tracking-tight">Good advice starts with <span className="italic text-brand">your game.</span></p>
        <p className="mt-6 max-w-sm text-base leading-relaxed text-muted">Your swing. Your equipment. Your goals. A place to understand how they fit together.</p>
        <div className="mt-10 max-w-sm border-t border-line pt-6">
          <p className="text-sm font-semibold">Independent by design.</p>
          <p className="mt-2 text-sm leading-relaxed text-muted">No affiliate links. No sponsored rankings. Keeping your current gear can be the right answer.</p>
        </div>
      </aside>
      <section aria-labelledby={titleId} className="mx-auto w-full max-w-lg rounded-xl border border-line bg-surface p-6 shadow-[0_10px_40px_-28px_#20392f50] sm:p-9">
        <header className="mb-7">
          <p className={`${eyebrowClass} mb-3 text-muted`}>Your place in the lab</p>
          <h1 id={titleId} className="font-serif text-3xl leading-tight tracking-tight text-ink sm:text-4xl">{title}</h1>
          {description && <p className="mt-3 text-sm leading-relaxed text-muted">{description}</p>}
        </header>
        {children}
        {footer && <div className="mt-6 border-t border-line pt-5 text-sm leading-relaxed text-muted">{footer}</div>}
      </section>
    </div>
  )
}
